import {isDeviceGranted, getDeviceId} from '@pexip/media-control';
import type {MediaDeviceInfoLike} from '@pexip/media-control';
import type {SelectProps} from '@pexip/components';
import {assert} from '@pexip/utils';

export interface MapDevicesToOptions {
    devices: MediaDeviceInfoLike[];
    defaultDeviceLabel: string;
    label: string;
    selectedDeviceId: string | undefined;
}

/**
 * Map MediaDeviceInfo to SelectProps['options']
 */
export const mapDevicesToOptions = ({
    devices,
    defaultDeviceLabel,
    label,
    selectedDeviceId,
}: MapDevicesToOptions): SelectProps['options'] => {
    if (devices.length === 0) {
        return [];
    }
    if (!devices.some(isDeviceGranted)) {
        const placeholder = devices.at(0);
        assert(placeholder, 'Placeholder device must be defined');
        return [
            {id: '', label},
            {
                id: getDeviceId(placeholder),
                label: defaultDeviceLabel,
            },
        ];
    }
    const deviceOptions = devices.map(device => ({
        id: getDeviceId(device),
        label: device.label,
    }));
    if (!selectedDeviceId) {
        return [{label, id: ''}, ...deviceOptions];
    }
    return deviceOptions;
};
